import { Injectable, inject } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  loadingController = inject(LoadingController);
  private readonly translateService = inject(TranslateService);


  async present(loadingId: string, loadingMessage: string): Promise<void> {
    const loading = await this.loadingController.create({
      id: loadingId,
      message: await firstValueFrom(this.translateService.get(loadingMessage)),
    });
    return await loading.present();
  }

  async dismiss(loadingId: string): Promise<boolean> {
    return await this.loadingController.dismiss(null, undefined, loadingId);
  }

  async find(loadingId: string): Promise<boolean> {
    const top = await this.loadingController.getTop();

    if (top) {
      if (top.id === loadingId) {
        return true;
      }
    }

    return false;
  }
}
